import { Checkbox } from '@repo/design-system-kit';
import { FormattedMessage } from 'react-intl';

interface TermsAndConditionsCheckboxProps {
  className?: string;
  errorMessage?: string;
  isSelected: boolean;
  isInvalid?: boolean;
  onChange: () => void;
  creditorName: string;
}

export function TermsAndConditionsCheckbox({
  className = 'mb-32',
  errorMessage,
  isSelected,
  isInvalid,
  onChange,
  creditorName,
}: TermsAndConditionsCheckboxProps) {
  return (
    <div data-testid="sdd-payment-link-terms-and-conditions">
      <Checkbox
        className={className}
        errorMessage={errorMessage}
        isInvalid={isInvalid}
        isSelected={isSelected}
        onChange={onChange}
      >
        <FormattedMessage
          id="sdd-collections.payment-link-page.mandate.terms-and-conditions"
          values={{ creditorName }}
        />
      </Checkbox>
    </div>
  );
}
